exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-menu.limited-height[data-v-18d42fbe]{max-height:250px;overflow-y:auto}", ""]);

// exports
